// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e174a117","455":"5673a015","977":"94629805"}[chunkId] + ".chunk.js";
};